export default __webpack_public_path__ + "static/media/passionate.fe94272a.svg";